package com.fantasytenis.shared.domain.tennis.usecases

import com.fantasytenis.shared.data.tennis.repository.TennisRepository
import com.fantasytenis.shared.domain.tennis.entity.TennisPlayerEntity
import com.fantasytenis.shared.domain.tennis.entity.MatchEntity
import com.fantasytenis.shared.domain.scoring.entity.MatchStatisticsEntity

/**
 * Get all players for a slate.
 */
class GetPlayersUseCase(
    private val tennisRepository: TennisRepository
) {
    suspend operator fun invoke(slateId: String? = null): Result<List<TennisPlayerEntity>> {
        return tennisRepository.getPlayers(slateId)
    }
}

/**
 * Get a single player by ID.
 */
class GetPlayerUseCase(
    private val tennisRepository: TennisRepository
) {
    suspend operator fun invoke(playerId: String): Result<TennisPlayerEntity> {
        return tennisRepository.getPlayer(playerId)
    }
}

/**
 * Get live matches.
 */
class GetLiveMatchesUseCase(
    private val tennisRepository: TennisRepository
) {
    suspend operator fun invoke(): Result<List<MatchEntity>> {
        return tennisRepository.getLiveMatches()
    }
}

/**
 * Get recently completed matches.
 */
class GetRecentlyCompletedMatchesUseCase(
    private val tennisRepository: TennisRepository
) {
    suspend operator fun invoke(
        hoursAgo: Int = 24,
        limit: Int = 20
    ): Result<List<MatchEntity>> {
        return tennisRepository.getRecentlyCompletedMatches(hoursAgo, limit)
    }
}

/**
 * Get upcoming matches.
 */
class GetUpcomingMatchesUseCase(
    private val tennisRepository: TennisRepository
) {
    suspend operator fun invoke(
        tournamentId: String? = null,
        limit: Int? = null
    ): Result<List<MatchEntity>> {
        return tennisRepository.getUpcomingMatches(tournamentId, limit)
    }
}

/**
 * Get match statistics.
 */
class GetMatchStatisticsUseCase(
    private val tennisRepository: TennisRepository
) {
    suspend operator fun invoke(matchId: String): Result<List<MatchStatisticsEntity>> {
        return tennisRepository.getMatchStatistics(matchId)
    }
}
